import React from "react";
import Shop from "../components/Shop";

const ShopPage = () => {
  return (
    <div>
      <Shop />
    </div>
  );
};

export default ShopPage;
